import { ProviderClient } from '@shared/providers/provider';
import { DeleteResult, InsertResult, PullResult, UpdateResult } from '@shared/providers/provider-transport';
import { DataField, DataFieldOption, DataObject } from '@shared/providers/types';
import { Flowstep } from '@shared/types/flowstep';
import { CancelToken } from '@shared/utils/cancelToken';
import * as QA from 'shared/utils/queryAnalysis';
import Highland from 'highland';
import { GeneratedReport, testReport50k, testReport150k, testReport300k } from './generated-report';

void Highland;

export class SalesforceClientReportProvider implements ProviderClient {
  private reports = new Map<string, GeneratedReport>();

  constructor() {
    this.reports.set(testReport50k.Id, testReport50k);
    this.reports.set(testReport150k.Id, testReport150k);
    this.reports.set(testReport300k.Id, testReport300k);
  }

  buildUrl(requestData: { flowstep?: Flowstep; objectId?: string }): Promise<string> {
    return Promise.resolve('');
  }

  async getFlowstepData(flowstep: Flowstep, cancelToken?: CancelToken): Promise<Highland.Stream<PullResult>> {
    const { objectType } = flowstep.providerOptions;
    const report = this.reports.get(objectType);

    if (!report) {
      throw new Error(`Client report not found: ${objectType}`);
    }

    return report.generateObjectStream();
  }

  async loadObjectFields(objectType: string): Promise<DataField[]> {
    const report = this.reports.get(objectType);

    if (!report) {
      return [];
    }

    return report.fields.map((field) => ({
      name: field.key,
      label: field.label,
      type: field.type,
      objectName: objectType,
      options: field.picklistValues?.map(
        (picklistValue) =>
          ({
            value: picklistValue.value,
            label: picklistValue.label,
          }) as DataFieldOption,
      ),
      hasMultiselectOptions: QA.isMultiselectPicklistField(field),
      originalField: field,
    }));
  }

  async loadObjectTypes(options?: { query: string }): Promise<DataObject[]> {
    const reports = Array.from(this.reports.values());

    const filtered = options?.query
      ? reports.filter((r) => r.Name.toLowerCase().includes(options.query.toLowerCase()))
      : reports;

    return filtered.map((report) => ({
      id: report.Id,
      name: report.Name,
      label: report.Name,
      originalType: report.reportInfo,
    }));
  }

  deleteFlowstepData(): Promise<Highland.Stream<DeleteResult>> {
    throw new Error('Method not implemented.');
  }

  insertFlowstepData(): Promise<Highland.Stream<InsertResult>> {
    throw new Error('Method not implemented.');
  }

  updateFlowstepData(): Promise<Highland.Stream<UpdateResult>> {
    throw new Error('Method not implemented.');
  }
}
